import React from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

interface ConfirmationModalProps {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  /** "danger" renders the confirm button in red — use for destructive actions. */
  variant?: "default" | "danger";
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  title = "Confirmation",
  message,
  onConfirm,
  onCancel,
  isLoading = false,
  variant = "default",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}) => {
  return (
    <Modal open={open} onClose={onCancel} title="" size="md">
      <div className="pr-6">
        <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
          {title}
        </h2>
        <div className="mt-3 text-gray-500 dark:text-gray-400 leading-relaxed">
          {message}
        </div>
      </div>
      <div className="mt-6 flex items-center justify-end gap-3">
        <Button
          variant="outline"
          onClick={onCancel}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>
        <Button
          color={variant === "danger" ? "danger" : "primary"}
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
